import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from 'sonner';

// Layout components
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import WhatsAppWidget from './components/layout/WhatsAppWidget';
import ScrollToTop from './components/common/ScrollToTop';

// Pages
import Home from './pages/Home';
import About from './pages/About';
import Blog from './pages/Blog';
import Contact from './pages/Contact';
import StartupServices from './pages/StartupServices';
import GST from './pages/GST';
import Registration from './pages/Registration';
import Compliances from './pages/Compliances';

import './App.css';

function App() {
  return (
    <HelmetProvider>
      <div className="App font-body">
        <BrowserRouter>
          <ScrollToTop />
          <Navbar />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<Blog />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/startup-services" element={<StartupServices />} />
              <Route path="/gst" element={<GST />} />
              <Route path="/registration" element={<Registration />} />
              <Route path="/compliances" element={<Compliances />} />
            </Routes>
          </main>
          <Footer />
          <WhatsAppWidget />
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
